import { Logs } from './Logs';
import { LiveLogs } from './Live';
import { Deployments } from './Deployments';
import { Features } from './Features';
import { Feature } from './Feature';
import { Variant } from './Variant';
import { Queue } from './Queue';
import { Queues } from './Queues';
import { Api } from './Api';
import { Notifications } from './Notifications';

export const system = {
  routes: [{
    component: Logs,
    path: '/logs',
    exact: true,
  }, {
    component: Logs,
    // Lucene query on query string
    path: '/logs/:type',
    exact: true,
  }, {
    component: Logs,
    // Search by account id
    path: '/logs/:type/:index/:text/:start',
    exact: true,
  }, {
    component: Logs,
    // Search by correlation id
    path: '/logs/:type/:index/:text',
    exact: true,
  }, {
    component: LiveLogs,
    path: '/live-logs',
    exact: true,
  }, {
    component: LiveLogs,
    path: '/live-logs/:services',
    exact: true,
  }, {
    component: Deployments,
    path: '/deployments',
    exact: true,
  }, {
    component: Features,
    path: '/features',
    exact: true,
  }, {
    component: Feature,
    path: '/features/:featureId',
    exact: true,
  }, {
    component: Variant,
    path: '/features/variants/:variantId',
    exact: true,
  }, {
    component: Queues,
    path: '/queues',
    exact: true,
  }, {
    component: Queue,
    path: '/queues/:queueName',
    exact: true,
  }, {
    component: Api,
    path: '/api',
    exact: true,
  }, {
    component: Notifications,
    path: '/notifications',
    exact: true,
  }],
};
